import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { NavigationExtras, Router } from '@angular/router';
import { ColorWithoutTitlePipe } from '../../pipes/color-without-title.pipe';
import { TitleWithoutColorPipe } from '../../pipes/title-without-color.pipe';
import { ProductSwatchesComponent } from '../product-swatches/product-swatches.component';
// import { RatingStarsComponent } from '../rating-stars/rating-stars.component';
import { RemoveTaaBerryPipe } from '../../pipes/remove-taa-berry.pipe';
// import gsap from 'gsap';
// import Flip from 'gsap/Flip';
// gsap.registerPlugin(Flip);

@Component({
  selector: 'app-product-card',
  imports: [
    CommonModule,
    ColorWithoutTitlePipe,
    TitleWithoutColorPipe,
    ProductSwatchesComponent,
    // RatingStarsComponent,
    RemoveTaaBerryPipe,
  ],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
})
export class ProductCardComponent {
  @Input('product') product: any = null;

  constructor(private router: Router) {}

  goToPDP(product: any, event: MouseEvent) {
    // event.preventDefault();
    const navigationExtras: NavigationExtras = {
      state: {
        product,
      },
    };
    if (typeof window !== 'undefined' && document?.startViewTransition) {
      document.startViewTransition(() => {
        this.router.navigate(
          ['/product', this.product.handle],
          navigationExtras
        );
      });
    } else {
      this.router.navigate(['/product', this.product.handle], navigationExtras);
    }
  }

  onProductSelected($event: any) {
    console.log('Product selected:', $event);
    this.product = $event;
  }
}
